import { Box, Typography, styled, Link } from "@mui/material";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { Outlet as RouterOutlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

import Loader from "components/Loader";
import { appHeight } from "helpers/pageHeight";

function Default() {
  const location = useLocation();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    appHeight();
    console.clear();
    console.log("Designed and Developed By Matican Group LLC");
  }, []);

  function checkImagesAreLoaded() {
    setLoading(true);

    setTimeout(() => {
      const loadedImages = [];
      const images = document.getElementsByTagName("img");

      if (images) {
        for (let i = 0; i < images.length; i++) {
          const element = images[i];
          if (element.complete) {
            loadedImages.push(element);
          }
        }
        if (loadedImages.length === images.length) {
          setLoading(false);
        } else {
          setTimeout(() => {
            checkImagesAreLoaded();
          }, 400);
        }
      }
    }, 4000);
  }

  useEffect(() => {
    checkImagesAreLoaded();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isOverview = location?.pathname === "/lipbalm/" || location?.pathname === "/lipbalm";

  return (
    <>
      <TransitionGroup>
        <CSSTransition key={location.key} timeout={450} classNames="fade">
          <Box>
            {/* <Header component={Link} to="/lipbalm/" headerIsCentered={headerIsCentered}>
              <img src={dafiLogo} alt="Dafi Logo" />
            </Header> */}

            <Loader loading={loading} />

            <RouterOutlet />

            <MaticanLink isOverview={isOverview}>
              <Link href="https://maticangroup.com/" target="_blank">
                By Matican Group LLC
              </Link>
            </MaticanLink>

          </Box>
        </CSSTransition>
      </TransitionGroup>
    </>
  );
}

const MaticanLink = styled(Box)(({ theme, isOverview }) => ({
  position: "absolute",
  width: "100%",
  display: isOverview ? "flex" : "none",
  justifyContent: "end",
  bottom: "10px",
  right: "10px",
  zIndex: 9999999,
  a: {
    textDecoration: "none",
    fontSize: "9px",
    color: theme.palette.primary.contrastText,
  },
  [theme.breakpoints.down("md")]: {
    justifyContent: "center",
    bottom: "10px",
    right: "0px",

    a: {
      fontSize: "8px",
    },
  },
}));

const PoweredTitle = styled(Typography)(({ theme, headerIsCentered }) => ({
  display: headerIsCentered ? 'block' : 'none',
  position: "fixed",
  bottom: 10,
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: 4,
  fontSize: "12px",
  fontWeight: 300,
  color: theme.palette.common.white
}));

export default Default;
